export default function Footer() {
  return (
    <footer style={{ marginTop: 50, textAlign: "center", fontSize: "0.9em" }}>
      <p>
        © {new Date().getFullYear()} AvisameSiBaja.com ·{" "}
        <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">Política de privacidad</a> ·{" "}
        <a href="/aviso-legal" target="_blank" rel="noopener noreferrer">Aviso legal</a> ·{" "}
        <a href="/terminos-condiciones" target="_blank" rel="noopener noreferrer">Términos y condiciones</a> ·{" "}
        <a href="/politica-cookies" target="_blank" rel="noopener noreferrer">Política de cookies</a> ·{" "}
        <a href="/precio/">Histórico de precios</a> ·{" "}
        <a href="/novedades/">Novedades</a> ·{" "}
        <a href="/blog" target="_blank" rel="noopener noreferrer">Blog</a> ·{" "}
        <a href="/blog/rss.xml" target="_blank" rel="noopener noreferrer">RSS</a> ·{" "}
        <a href="/boton-navegador">Botón para el navegador</a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            localStorage.removeItem("cookiesAccepted");
            window.location.reload();
          }}
          style={{ marginLeft: "12px", textDecoration: "underline", cursor: "pointer" }}
        >
          Cambiar preferencias de cookies
        </a>
      </p>
      <p style={{
        fontSize: "0.75rem",
        color: "#666",
        textAlign: "center",
        marginTop: "2rem",
        padding: "1rem",
        borderTop: "1px solid #ddd"
      }}>
        <strong>Nota:</strong> Esta web no está afiliada, patrocinada ni asociada de ninguna forma con Amazon ni Amazon.es. Amazon.es es una marca registrada de Amazon.com, Inc. y sus empresas afiliadas.<br/>
        En calidad de Afiliado de Amazon, obtengo ingresos por las compras adscritas que cumplen los requisitos aplicables. Algunos enlaces a productos pueden ser enlaces de afiliado. Si compras a través de ellos, nosotros podemos recibir una pequeña comisión, sin que ello suponga un coste adicional para ti. Esto nos ayuda a mantener el servicio gratuito.<br />
        Cualquier pregunta o inquietud: <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a>
      </p>
    </footer>
  );
}
